export function money(v, currency = "KES") {
  const n = Number(v || 0);
  return `${currency} ${n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function fmtDate(d) {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
  } catch {
    return String(d).slice(0, 10);
  }
}

export const ROLE_LABELS = {
  super_admin: "Super Admin",
  property_manager: "Property Manager",
  property_admin: "Property Admin",
  accountant: "Accountant",
  staff: "Staff",
};

export const PROPERTY_TYPES = ["Apartment", "Maisonette", "Villa", "Office", "Warehouse", "Mixed Use", "Bungalow", "Studio"];
export const PROPERTY_CATEGORIES = ["Residential", "Commercial", "Industrial"];
export const PROPERTY_STATUS = ["Vacant", "Occupied", "Under Maintenance"];
export const BILLING_FREQUENCIES = [
  { value: "monthly", label: "Monthly" },
  { value: "bi_monthly", label: "Bi-Monthly" },
  { value: "quarterly", label: "Quarterly" },
  { value: "semi_annual", label: "Semi-Annual" },
  { value: "annual", label: "Annual" },
  { value: "custom", label: "Custom" },
];
